'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    tabContainer: {
      position: 'relative',
      '&.bottomLine:before': {
        content: '""',
        position: 'absolute',
        left: 0,
        bottom: 0,
        right: 0,
        height: 1,
        backgroundColor: theme.tab.borderBottomContainerColor
      }
    },
    tabs: {
      display: 'flex',
      alignItems: 'stretch',
      position: 'relative'
    }
  };
};